import { render, staticRenderFns } from "./GruposSede.vue?vue&type=template&id=b5c893c8&scoped=true&"
import script from "./GruposSede.vue?vue&type=script&lang=js&"
export * from "./GruposSede.vue?vue&type=script&lang=js&"
import style0 from "./GruposSede.vue?vue&type=style&index=0&id=b5c893c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c893c8",
  null
  
)

export default component.exports